import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import ConfirmSuccess from "../core/ui/confirm-success";
import SessionContext from "SessionContext";

export default function CompareList() {
  const history = useHistory();
  const session = useContext(SessionContext);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [reportToDelete, setReportToDelete] = useState({});
  const [chartsLoaded, setChartsLoaded] = useState(false);
  const [pendingOrderNavigation, setPendingOrderNavigation] = useState(null);

  const table_columns = [
    { header: "Comparison Report Name", key: "name" },
    { header: "Description", key: "description" },
    { header: "Created", key: "created_date" },
    { header: "Created By", key: "created_by" },
    { header: "Status", key: "report_status", render: (value) => 
      <span className="report-list-status">
        {value?.report_status.charAt(0) + value.report_status.slice(1).toLowerCase() }
      </span> 
    },
  ];

  const toggleDeleteModal = () => {
    if(showDeleteModal) {
      setReportToDelete({});
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const onFinalDeleteReport = () => {
    session.command("compare/delete", reportToDelete, {}, { defaultErrorHandling: false })
      .then(() => {
        toggleDeleteModal();
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        console.log("Delete Failed", JSON.stringify(err));
      })
  }

  const handleDelete = (_val) => {
    setReportToDelete(_val);
    toggleDeleteModal();
  }

  const handleEdit = (_val) => {    
    session.crossfilterStore.restoreFromAudience("clear_all");
    if(session.crossfilterStore.explorerModule !== "consumers") {
      session.crossfilterStore.setExplorerModule("consumers");
    }

    if(chartsLoaded) {
      // Already loaded — navigate immediately
      history.push(`/compare-audiences#id=${_val.id}`)
    } else {
      // Not yet loaded — store the order and wait
      setPendingOrderNavigation(_val);
    }
    
  }

  const handleDetails = (_val) => {
    history.push(`/compare-report-details#id=${_val.id}`)
  }

  useEffect(() => {
    if(chartsLoaded !== session.chartsStore.loaded) {
      setChartsLoaded(session.chartsStore.loaded);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.chartsStore.loaded]);

  useEffect(() => {
    if (chartsLoaded && pendingOrderNavigation) {
    const destination = pendingOrderNavigation === "new"
      ? "/compare-audiences"                                   // new report route
      : `/compare-audiences#id=${pendingOrderNavigation.id}`;  // edit route
    setPendingOrderNavigation(null);
    setTimeout(() => {
      history.push(destination);
    }, 300);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartsLoaded, pendingOrderNavigation]);

  const table_actions = (_row) => {
    let is_completed = _row.report_status === "COMPLETED";
    return (
    <ul id="action-menu" className="action-menu">
      <li>
        {is_completed ? 
        <Button color="link" size="sm" onClick={() => handleDetails(_row)}>
          <i className="bi bi-eye" /> Report Details
        </Button> : 
        <Button color="link" size="sm" onClick={() => handleEdit(_row)}>
          <i className="bi bi-pencil" /> Edit Report
        </Button>}
        
        <Button color="link" size="sm" onClick={() => handleDelete(_row)}>
          <i className="bi bi-trash" /> Delete
        </Button>
      </li>
    </ul>
  )};

  const onClickNew = (ev) => {
    ev.stopPropagation();

    session.crossfilterStore.restoreFromAudience("clear_all");
    if(session.crossfilterStore.explorerModule !== "consumers") {
      session.crossfilterStore.setExplorerModule("consumers");
    }

    if(chartsLoaded) {
      history.push("/compare-audiences");
    } else {
      setPendingOrderNavigation("new");
    }
  }

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <h1>Compare</h1>
        <i className="spacer" />
        <Button className='new-button' onClick={onClickNew}>New Audience Comparison Report</Button>
      </div>
      <div className="roles-main margin-top-1">
        <DataTable
          query="compare/list"
          cols={table_columns}
          actions={table_actions}
          empty="No Comparison Reports Found"
        />
      </div>
      <Modal centered backdrop
        isOpen={showDeleteModal}
      >
        <ModalHeader>
          Delete Report
        </ModalHeader>
        <ModalBody>
          <Alert color="light" className="d-flex">
            <i className="bi bi-exclamation-octagon"></i>
            <div>
              Selecting <b>delete</b> will permanently remove all instances from AudienceMaker and cannot be undone. Are you sure you want to continue?
            </div>
          </Alert>
          <Alert color="light" className="">
            <p>
              <span className="header-modal-text">Report Name</span>
              <span className="d-block ms-3">{reportToDelete.name}</span>
            </p>
            <p>
              <span className="header-modal-text">Description</span>
              <span className="d-block ms-3">{reportToDelete.description}</span>
            </p>
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button className="promote" onClick={toggleDeleteModal}>Cancel</Button>
          <Button onClick={onFinalDeleteReport}>Delete</Button>
        </ModalFooter>
      </Modal>
      <ConfirmSuccess show={showSuccess} label="Report deleted successfully." />
    </div>
  );
}
